export default class AnimationScrollPage {
  constructor() {
    this.$el = $('.animation')
    this.winH = window.innerHeight
    this.winW = window.innerWidth
    this.offset = window.innerHeight
    this.WindowScrollTop = null
    this.topCurrent = null
    this.addClassAni = 'set-animation'
  }

  init() {
    this.animationEle()
    $(window).on('scroll resize', () => {
      this.animationEle()
    })
  }

  formatNumber(text, min, max) {
    return text.toLocaleString('en-US', {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    })
  }

  animationNumber($el) {
    const numberCount = parseFloat($el.attr('data-numbercounter'))
    const $parent = $el.closest('[data-duration]')
    const durationAnima = $parent.attr('data-duration') ? parseFloat($parent.attr('data-duration')) : 4000
    $el.addClass('counted')
    $el.prop('Counter', 0).animate({
      Counter: numberCount,
    }, {
      duration: durationAnima,
      easing: 'swing',
      step: (now) => {
        $el.text(this.formatNumber(Math.floor(now), 0, 2))
      },
      complete: () => {
        $el.text(this.formatNumber(numberCount, 0, 2))
      },
    })
  }

  animationEle() {
    this.offset = this.winH
    if ($('.wrapper').hasClass('has-animation')) {
      this.WindowScrollTop = $(window).scrollTop()
      this.$el.each((_index, ele) => {
        const $elm = $(ele)
        if ($elm.hasClass(this.addClassAni)) {
          return true
        }
        this.topCurrent = $elm.offset().top
        if (this.WindowScrollTop > this.topCurrent - this.offset) {
          $elm.addClass(this.addClassAni)
          if ($elm.hasClass('number-counter') && !$elm.hasClass('counted')) {
            this.animationNumber($elm)
          }
          return true
        }
        return false
      })
    }
  }
}

new AnimationScrollPage().init()
